import React, { PureComponent } from "react";
import { ProductSummary } from "~/action-panel/components/common/product-blend-summary/product-summary";

export class RecManualApplicationSummary extends PureComponent {
    render() {
        return <ProductSummary isEvent={false} isEquation={false} />;
    }
}
